export default {
  product: {
    title: 'Produkto',
    selfCustodyWallet: 'Mobile na Wallet',
    selfCustodyWalletDesc: 'Crypto&DeFi Mobile Wallet sa Blockchain.',
    hardwareWallet: 'Hardware na Wallet',
    hardwareWalletDesc:
      'Kunin ang Iyong KeyPal, para Bantayan ang Iyong Mga Asset.',
    extensionWallet: 'Extension na Wallet',
    extensionWalletDesc: 'Isang Mas Mahusay na Wallet sa Iyong Computer.',
    transit: 'Transit',
    transitDesc: 'Multi-chain DEX Aggregator at NFT Marketplace Platform.',
    fiveDegrees: '5Degrees',
    fiveDegreesDesc: 'Social Network Protocol sa Web3.0.',
    stakeVault: 'ETH Staking Vault',
    stakeVaultDesc:
      'Sinusuportahan ang self-custodial staking at small amount staking',
  },
  project: {
    subToken: 'I-submit ang Token',
    subDApp: 'I-submit ang DApp',
    subNFT: 'I-submit ang NFT',
    subChain: 'Isumite ang Chain',
  },
  assets: {
    title: 'Mga asset',
  },
  collaborations: {
    title: 'pakikipag-kolaborasyon',
  },
  community: {
    title: 'Komunidad',
    developers: 'mga developer',
    recruiting: 'TP Man',
  },
  helpCenter: {
    title: 'Tulong',
  },
  features: {
    title: 'Mga tampok',
    buyCrypto: 'Bumili ng Crypto',
    mobileWallet: 'Mobile na Wallet',
    hardwareWallet: 'Hardware na Wallet',
    extensionWallet: 'Extension na Wallet',
    desktop: 'Desktop na Wallet',
    fiveDegrees: '5Degrees',
    versionVerification: 'Version Verification',
    approvalDetector: 'Detektor ng Pag-apruba',
    tokenSecurity: 'Seguridad ng Token',
    keyGenerator: 'Key Generator',
    BATCH_SENDER: 'Batchsender',
  },
  information: {
    title: 'Impormasyon',
    blockchainGuide: 'Gabay sa Blockchain',
    tronWallet: 'Gabay sa TRON',
    iostWallet: 'Gabay sa IOST',
    tpMan: 'TP Man',
  },
  developers: {
    title: 'Mga developer',
    github: 'Github (TP-Lab)',
    devCenter: 'Dev Center',
    subToken: 'I-submit ang Token',
    subDApp: 'I-submit ang DApp',
    subNFT: 'I-submit ang NFT',
  },
  company: {
    title: 'kumpanya',
    about: 'Tungkol sa',
    careers: 'Mga Career',
    pressKit: 'Pindutin ang Kit',
    swagShop: 'Swag Shop',
  },
  support: {
    title: 'Suporta',
    helpCenter: 'Help Center',
    contactUs: 'Makipag-ugnayan sa amin',
  },
  legal: {
    title: 'Legal',
    privacyPolicy: 'Patakaran sa Privacy',
    terms: 'Mga Tuntunin ng Paggamit',
  },
  main: {
    title: 'Pagpapatunay ng Bersyon',
    language: 'Filipino',
    intro:
      'Ang pagpapatunay ng bersyon ay isinasagawa sa pamamagitan ng pagtugma ng mga halaga ng MD5 o SHA256 hash sa pagitan ng mga bersyon. Mangyaring tiyakin na i-download ang TokenPocket wallet sa pamamagitan ng mga opisyal na channel upang maiwasan ang pagkakaloko. Para sa mga tagubilin kung paano makakuha ng mga halaga ng MD5 o SHA256 hash ng isang bersyon, mangyaring ',
    tutorial: 'tingnan ang tutorial >',
    system: 'OS',
    android: 'Android',
    ios: 'iOS',
    version: 'Bersyon',
    allVersion: 'Lahat',
    appChannel: 'App Channel',
    developer: 'developer',
    allChannel: 'Lahat',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Tala ng Bersyon',
    check: 'Detalye',
    versionLog: 'Tala ng Bersyon',
    confirm: 'Kumpirmahin',
    aboutIOS: 'Tungkol sa iOS Version',
    IOSDesc:
      'Para sa mga bersyon ng iOS, kami lamang ang nag-aalok ng aming App sa App Store. Tanging mga apps na i-download sa pamamagitan ng App Store ang maaaring maayos na ma-install. Kaya kapag gumagamit ng mga Apple device, tiyakin na authenticated ang App Store bilang eksklusibong channel para sa pag-download.',
    IOSDesc_2:
      'Ang developer ng bersyon na i-download mula sa App Store bago ang Oktubre 8, 2022 ay ang TOKENPOCKET FOUNDATION LTD, na isang maagang bersyon na binuo ng TokenPocket. Ito ay isang lehitimong wallet na maaaring normal na gamitin, ngunit pansamantalang suspindihin ang serbisyo ng pag-update.',
    aboutAndroid: 'Tungkol sa Bersyon ng Android',
    androidDesc: 'Ang mga channel ng pag-download ng TokenPocket para sa Android kasalukuyang kasama ang opisyal na website, Google Play Store, Samsung App Store, Huawei AppGallery, OPPO App Store, at Vivo App Store. Sa ilang mga app store, hindi makuha ang APK installation package habang nagdodownload, kaya hindi maaaring isagawa ang MD5 o SHA256 verification. Kaya, sa pag-download, tiyaking tumpak ang impormasyon ng developer at sumangguni sa ibaba!',
    IOSAppName: 'Pangalan ng Application:',
    TPWallet: 'TP Wallet',
    AppIcon: 'App Icon:',
    AppDeveloper: 'Developer:',
    downloadLink: 'Link ng Pag-download:',
    copied: 'Nakopya!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Sundan mo kami',
    desc1:
      'Ang TokenPocket Staffs ay hindi magpapadala sa iyo ng mga pribadong mensahe!',
    desc2:
      'Ingat! Pumapasok ka sa komunidad ng TokenPocket, maaaring may gumagaya sa amin para magpadala sa iyo ng mga pribadong mensahe! Mangyaring magkaroon ng kamalayan na, sinuman na nagpapadala ng mga pribadong mensahe ay maaaring isang scammer! Hindi ka muna namin makokontak!',
    desc3: 'Naiintindihan, pumasok',
  },
};
